
import { Component, Prop, Vue ,Model ,Watch } from "vue-property-decorator";
import previewImg from './previewImg.vue'
@Component({
    name: 'step-component',
    components: {
      previewImg
    }
})
export default class StepComponent extends Vue {
  @Prop({default:''}) url!: string;
  @Prop({default:60}) width!: number;
  @Prop({default:60}) height!: number;
  @Prop({default:()=>{return []}}) previewlist!:any
  private show = false
  private filetype = 'image'


  private created () {

  }

  private preview(){
    this.show = true
  }
}
